import { createWidget } from '@alfa-bank/site-util-create-widget';
import { MarkdownContainerV2Desktop as MarkdownContainer } from '@alfa-bank/site-markdown-container-v2/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { TBlogContentBody, TBlogContentBodyDeps } from './models';
import { BlogContentBody as Component } from './blog-body-content';
import { configDesktop as config } from './helpers/config';

export const BlogContentBodyDesktop = createWidget<TBlogContentBodyDeps, TBlogContentBody>({
    MarkdownContainer,
    Text,
    config,
})(Component);
